import { createReducer } from 'typesafe-actions';
import {
  INIT_CHAT_MESSAGES,
  UPDATE_CHAT_MESSAGES,
  READ_CHAT_MESSAGES
} from './actions';
import { Action, SubscribeMessage } from './types';

export const initialState: SubscribeMessage[] = [];

export const chatMessages = createReducer<SubscribeMessage[], Action>(
  initialState,
  {
    [INIT_CHAT_MESSAGES]: () => {
      return [];
    },
    [UPDATE_CHAT_MESSAGES]: (state, action) => {
      const nextState = [action.payload, ...state];
      return nextState;
    },
    [READ_CHAT_MESSAGES]: (state) => {
      return state.map((message) => ({ ...message, unReadCount: 0 }));
    }
  }
);
